import {
    BindDockingVo,
    LoadUsingGet1Params,
    QueryPeopleConfigByFullNameUsingGetParams
} from '@servicesTypings/drpRequest'
import { drpRequest } from '@/utils/request'

// 启用平台组织对接人
export function queryOperation(params) {
    return drpRequest.get('/op/supplier/gylDockingPeopleConfig/list', {
        params: {
            ...params
        }
    })
}

/**
 * 查询分销商绑定的业务员列表
 */
export function getChannelBindSalesmanList() {
    return drpRequest.get('/op/partner/getFreshmanBindSalesmanList')
}

/**
 * 添加平台组织对接人信息配置表 (转换包含中文无法完全转换)
 */
export function createOperation(data: any): API.Res<object> {
    return drpRequest.post('/op/supplier/gylDockingPeopleConfig/insert', { data })
}

/**
 * 修改平台组织对接人信息配置表 (转换包含中文无法完全转换)
 */
export function updateOperation(data: any): API.Res<object> {
    return drpRequest.post('/op/supplier/gylDockingPeopleConfig/update', { data })
}

// 渠道根据邀请绑定对接运营
/**
 * 渠道根据邀请绑定对接运营
 */
export function bindBuyerAndDockingPeople(data: BindDockingVo): API.Res<object> {
    return drpRequest.post('/op/gylOrgInviteCode/bindBuyerAndDockingPeople', { data })
}

// 供应商根据邀请绑定对接运营
/**
 * 供应商根据邀请绑定对接招商
 */
export function bindSupplierAndDockingPeople(data: BindDockingVo): API.Res<object> {
    return drpRequest.post('/op/gylOrgInviteCode/bindSupplierAndDockingPeople', { data })
}

/**
 * 加载对接人信息详情 (转换包含中文无法完全转换)
 */
export function queryDockingPeopleConfig(params: LoadUsingGet1Params): API.Res<any> {
    return drpRequest.get('/op/supplier/gylDockingPeopleConfig/load', { params })
}

// ka 小组
/**
 * 查询运营组
 */
export function queryKaList(): API.Res<string[]> {
    return drpRequest.get('/op/kaCustomerAnalysis/queryOperationGroup')
}

// 加载对接人信息详情
/**
 * 加载对接人信息详情 (转换包含中文无法完全转换)
 */
export function queryPeopleConfigByFullName(params: QueryPeopleConfigByFullNameUsingGetParams): API.Res<any> {
    return drpRequest.get('/op/supplier/gylDockingPeopleConfig/queryPeopleConfigByFullName', { params })
}
